import template from './pop-up-detail.html';
import controller from './pop-up-detail.controller';
import './pop-up-detail.scss';

let popUpDetailComponent = {
  bindings: {},
  template,
  controller
};

export default popUpDetailComponent;


// WEBPACK FOOTER //
// ./client/app/components/pop-up/pop-up-detail.component.js